/**
 * Godot's node ancestry: every type → the base it derives from. `CLASS_BASE_TYPES` merges it with the
 * resource table, and every ancestry walk reads it there: `ValidatorRegistry.findValidator`, so a set on
 * `Node3D` or `Control` reaches every subclass, and `descendsFromClass`. Derived from the catalog's `chain` (`nodeBaseTypes.generated.ts`) with every
 * hop, so a validator on an intermediate such as `GeometryInstance3D` reaches its subclasses.
 */
import { CATALOG_BASE_TYPES } from './nodeBaseTypes.generated.js';
/**
 * Types Godot 4.6.3's ClassDB does not enumerate, each with its reason. An entry for a catalogued type
 * that names another base would shadow the engine's answer, which `linter/baseChainCompleteness.test.ts`
 * rejects.
 */
const UNCATALOGUED = {
    // Added after the pinned build: the current class reference lists it under Light3D's "Inherited
    // By", and scenes name it (3d/lights/arealight3d). The catalog supplies it once the pin moves.
    AreaLight3D: 'Light3D',
};
export const NODE_BASE_TYPES = Object.freeze({
    ...CATALOG_BASE_TYPES,
    ...UNCATALOGUED,
});
/**
 * Whether Godot's ClassDB knows this class name. `Node` is the terminal, with no entry of its own.
 * `descendsFromClass` returns false both for a known non-subclass and for an unknown class, and a rule
 * that conflates them judges the hierarchy of a GDExtension it cannot see.
 */
export function isCatalogedType(nodeType) {
    return nodeType === 'Node' || Object.hasOwn(NODE_BASE_TYPES, nodeType);
}
//# sourceMappingURL=nodeBaseTypes.js.map